<!--  -->
<template>
  <div>
    <div class="dease_box">
      <div
        v-for="item,index in themarr"
        :key="index"
        class="card"
        @click="deaseitem(item)"
      >
        <p class="demonstration">{{ item.name }}</p>
        <div class="el-image">
          <img :src="item.url" class="elawe" alt="">
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      platformid: null,
      themarr: [],
      type: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(val) {
      this.themarr = val
    },
    deaseitem(item) {
      console.log('item', item)
      this.$emit('close', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.card{
    margin-bottom: 10px;
    border: 1px solid #eee;
    width: 334px;
    margin-right: 10px;
}
.demonstration{
      text-align: center;
    cursor: pointer;
    box-sizing: border-box;
}
.el-image{
    cursor: pointer;
    display: inherit;
}
.elawe{
  width: 100%;
  height: 100%;
}
.dease_box{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  /* justify-content: center; */
  height: 680px;
  overflow: hidden;
  overflow-y:scroll
}
</style>
